<template>
  <el-dialog
    title="个人设置"
    :visible.sync="visible"
    label-width="100px"
    width="500px"
    @close="$emit('update:show', false)"
    @open="opend"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="头像" prop="avatar" class="avatar">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          accept="image/*"
          :headers="uploadHeader"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeAvatarUpload"
        >
          <auth-img v-if="model.avatar" :src="model.avatar" class="avatar" />
          <img v-else src="../assets/avatar.jpeg" class="avatar" />
        </el-upload>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="model.name"
          maxlength="15"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone_number">
        <el-input
          v-model="model.phone_number"
          autocomplete="off"
          maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="model.email" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="new_password">
        <el-input
          v-model="model.new_password"
          type="password"
          placeholder="修改密码填写"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="repeat_password">
        <el-input
          v-model="model.repeat_password"
          type="password"
          placeholder="修改密码填写"
        ></el-input>
      </el-form-item>
      <el-form-item label="旧密码" prop="old_password">
        <el-input
          v-model="model.old_password"
          placeholder="修改密码填写"
          type="password"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { urlPerfix } from '@/config/env'
import { userSet } from '@/service/getData'
import store from '@/store/store'
import { clone } from '@/util'
import { getStore } from '@/config/storage'

const allLetters = 'abcdefghijklmnopqrstuvwxyz'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      } else {
        this.model = clone(store.state.userInfo)
      }
    },
  },
  created() {
    this.model = clone(store.state.userInfo)
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        this.$refs.form.validateField('repeat_password')
        this.$refs.form.validateField('old_password')
        callback()
      } else {
        if (this.model.repeat_password !== '') {
          this.$refs.form.validateField('repeat_password')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.model.new_password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    var validatePass3 = (rule, value, callback) => {
      if (this.model.new_password !== '' && value === '') {
        callback(new Error('旧密码不能为空!'))
      } else {
        callback()
      }
    }

    return {
      model: {},
      uploadUrl: urlPerfix + '/files/upload?t=private',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 15 个字符',
            trigger: 'blur',
          },
        ],
        new_password: [
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              let password = value.toLowerCase()
              // 密码3位比对
              for (let i = 0; i < password.length - 2; i++) {
                let n1 = password[i]
                let n2 = password[i + 1]
                let n3 = password[i + 2]
                // 判断重复字符
                if (n1 === n2 && n1 === n3) {
                  callback('密码不能包含连续3位重复的字符')
                  return
                } else if (allLetters.includes(n1 + n2 + n3)) {
                  callback('密码不能包含连续3位正序排列的字母字符')
                  return
                }
              }
              callback()
            },
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              var passwordreg =
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,16}/
              if (value && !passwordreg.test(value)) {
                callback(
                  '密码必须包含大小字母、数字和特殊符号，且长度为8到16位！'
                )
              } else {
                callback()
              }
            },
          },
          { validator: validatePass, trigger: 'blur' },
        ],
        repeat_password: [{ validator: validatePass2, trigger: 'blur' }],
        // old_password: [{ validator: validatePass3, trigger: 'blur' }],
        phone_number: [
          {
            required: true,
            pattern: /^1\d{10}$/,
            message: '手机号错误',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    opend() {
      this.$set(this.model, 'new_password', '')
      this.$set(this.model, 'repeat_password', '')
      this.$set(this.model, 'old_password', '')
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.model.avatar = res.data
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = true
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await userSet(this.model)
            if (res.code == 0) {
              this.visible = false
              let userInfo = getStore('costUserInfo')
              userInfo.name = res.data.name
              userInfo.phone_number = res.data.phone_number
              userInfo.avatar = res.data.avatar
              userInfo.email = res.data.email
              store.commit('login', userInfo)
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style>
.avatar-uploader img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.avatar .el-form-item__label {
  line-height: 60px !important;
}
</style>